import { useCallback } from "react";
import { useAtom } from "jotai";
import { catalogDbAtom } from "./catalog.state";
import { loadCatalogsDb } from "./catalog.service";
import { sessionAtom } from "../accounts/account.state";

export const useCatalogs = () => {
  const [catalogDb, setCatalogDb] = useAtom(catalogDbAtom);
  const [session] = useAtom(sessionAtom);

  const reloadCatalogDb = useCallback(async () => {
    if (!session?.account?.config?.imageStorageUrl) return;

    const db = await loadCatalogsDb(session.account.config.imageStorageUrl);
    setCatalogDb(db);
  }, [session?.account?.config?.imageStorageUrl, setCatalogDb]);

  return {
    catalogDb,
    reloadCatalogDb,
  };
};
